/**
 * Refresh access token via Wireless Sales SDK.
 * @memberof posPlatform.wireless
 * @function refreshToken
 * @returns {Promise} Promise object represents access token
 */
export default function refreshToken() {
    const token = window.WS_RequestRefreshToken();

    if (!token) return Promise.reject({ token });

    return Promise.resolve(token);
}